import { gql } from "@apollo/client";
import { VendorNoNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const MUTATION_COMPLETE_ONBOARDING = gql`
  ${VendorNoNestingFragment}
  mutation MutationCompleteOnboarding($input: CompleteOnboardingInput!) {
    completeOnboarding(input: $input) {
      ...VendorNoNesting
    }
  }
`;
